export const PRIME_NG_FR = {
  password: {
    passwordPrompt: 'Entrez un mot de passe',
    weak: 'Faible',
    medium: 'Moyen',
    strong: 'Fort',
  },
};
